import moment from 'moment'
import { Logger } from '~/plugins/log'
const logger = new Logger()
logger.setContext('Story')

const getDefaultState = () => ({
  stories: [],
  storiesBySlug: {},
  count: 0,
  lastUpdate: null
})

export const state = getDefaultState

export const mutations = {
  RESET (state) {
    Object.assign(state, getDefaultState())
  },
  SET (state, response) {
    state.count = response.count
    
    const stories = [...state.stories, ...response.results].sort(
      (a, b) => moment(b.date) - moment(a.date)
    )
    
    const uniqueStories = []
    stories.forEach((story) => {
      if (uniqueStories.find(search => search.id === story.id)) return
      uniqueStories.push(story)
    })
    state.stories = uniqueStories

    state.lastUpdate = (new Date()).valueOf()
  },
  SET_STORY_BY_SLUG (state, { slug, data }) {
    state.storiesBySlug = {
      ...state.storiesBySlug,
      [slug]: data
    }
  }
}

export const getters = {
  stories: state => state.stories,
  count: state => state.count,
  numberLoaded: state => state.stories.length,
  story: state => slug => state.storiesBySlug[slug] || {}
}

export const actions = {
  async LIST ({ commit }) {
    try {
      const { data } = await this.$publicAPI.get('stories/?limit=50')
      commit('SET', data)
    } catch (error) {
      this.app.$sentry.captureException(error)
      logger.error(error)
    }
  },
  async GET_LATEST ({ commit }) {
    try {
      const { data } = await this.$publicAPI.get('stories/?limit=1')
      commit('SET', data)
    } catch (error) {
      this.app.$sentry.captureException(error)
      logger.error(error)
    }
  },
  async GET_MORE ({ commit, state }) {
    try {
      const { data } = await this.$publicAPI.quietGet(`stories/?limit=50&offset=${state.stories.length}`)
      commit('SET', data)
    } catch (error) {
      this.app.$sentry.captureException(error)
      logger.error(error)
    }
  },
  async GET ({ commit, state }, slug) {
    try {
      const { data } = await this.$publicAPI.get(`stories/${slug}/`)
      commit('SET_STORY_BY_SLUG', { slug, data })
      return data
    } catch (error) {
      this.app.$sentry.captureException(error)
      logger.error(error)
    }
    return {}
  }
}
